module.exports = __webpack_public_path__ + "9a7fbf599da31cd8076da23817ef3ef5.png";